import api from '../services/Api';
import { homepageDataLoadedAction } from '../actions/CompoundFetchActions';
import { networkErrorAction } from '../actions/UiActions';
import { HOMEPAGE_ACTIVE_PAGE_SIZE, HOMEPAGE_CLOSED_PAGE_SIZE } from '../parameters';
import CompoundFetch from '../helpers/CompoundFetch';

class HomepageRepository {

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchHomepageData = () => (dispatch) => api.post('/compound-fetch', {
		activeOrComingSoonRaffles: `/raffles/active-or-coming-soon?pageSize=${HOMEPAGE_ACTIVE_PAGE_SIZE}`,
		closedRaffles: `/raffles/closed?pageSize=${HOMEPAGE_CLOSED_PAGE_SIZE}`,
		carouselRaffles: '/raffles/carousel'
	}).then(res => {
		const data = res.data;
		let activeOrComingSoonRaffles = CompoundFetch.parseSubRequest(dispatch, data.activeOrComingSoonRaffles, 'Active Or Coming Soon Raffles');
		let closedRaffles = CompoundFetch.parseSubRequest(dispatch, data.closedRaffles, 'Closed Raffles');
		let carouselRaffles = CompoundFetch.parseSubRequest(dispatch, data.carouselRaffles, 'Carousel Raffles');

		if (activeOrComingSoonRaffles && closedRaffles && carouselRaffles) {
			dispatch(homepageDataLoadedAction(
				activeOrComingSoonRaffles,
				closedRaffles,
				carouselRaffles
			));
		}
		else {
			const msg = 'Compound fetch returned invalid data.';
			dispatch(networkErrorAction(msg));
		}
	});

}

export default new HomepageRepository();


// WEBPACK FOOTER //
// ./repositories/HomepageRepository.js